export const ORGAOS = [
    { label: 'CARUARUPREV', value: 'CARUARUPREV' },
    { label: 'Central de Abastecimento de Caruaru', value: 'Central de Abastecimento de Caruaru' },
    { label: 'Autarquia Municipal de Defesa Social, Trânsito e Transporte', value: 'Autarquia Municipal de Defesa Social, Trânsito e Transporte' },
    { label: 'Fundação de Cultura e Turismo de Caruaru', value: 'Fundação de Cultura e Turismo de Caruaru' },
    // { label: 'Gerência de Proteção Animal', value: 'Gerência de Proteção Animal' },
    // { label: 'PROCON', value: 'PROCON' },
    // { label: 'Controladoria do Município', value: 'Controladoria do Município' },
    { label: 'Gabinete da Prefeita', value: 'Gabinete da Prefeita' },
    // { label: 'Procuradoria Geral do Município', value: 'Procuradoria Geral do Município'},
    { label: 'Secretaria da Fazenda', value: 'Secretaria da Fazenda' },
    { label: 'Secretaria de Administração', value: 'Secretaria de Administração' },
    { label: 'Secretaria de Desenvolvimento Econômico e Economia Criativa', value: 'Secretaria de Desenvolvimento Econômico e Economia Criativa' },
    { label: 'Secretaria de Desenvolvimento Social e Direitos Humanos', value: 'Secretaria de Desenvolvimento Social e Direitos Humanos' },
    { label: 'Secretaria de Educação', value: 'Secretaria de Educação' },
    { label: 'Secretaria de Governo', value: 'Secretaria de Governo' },
    { label: 'Secretaria de Ordem Pública', value: 'Secretaria de Ordem Pública' },
    { label: 'Secretaria de Planejamento, Orçamento e Gestão', value: 'Secretaria de Planejamento, Orçamento e Gestão' },
    { label: 'Secretaria de Políticas para Mulheres', value: 'Secretaria de Políticas para Mulheres' },
    { label: 'Secretaria de Saúde', value: 'Secretaria de Saúde' },
    { label: 'Secretaria de Serviços Públicos', value: 'Secretaria de Serviços Públicos' },
    { label: 'Secretaria de Sustentabilidade e Desenvolvimento Rural', value: 'Secretaria de Sustentabilidade e Desenvolvimento Rural' },
    { label: 'Secretaria de Urbanismo e Obras', value: 'Secretaria de Urbanismo e Obras' },
    // { label: 'Secretaria Executiva de Impresa e Comunicação', value: 'Secretaria Executiva de Impresa e Comunicação' },
    { label: 'Secretaria Extraordinária da Feira de Caruaru', value: 'Secretaria Extraordinária da Feira de Caruaru' },
    { label: 'Secretaria Executiva de Infraestrutura', value: 'Secretaria Executiva de Infraestrutura' },
    { label: 'Secretaria Executiva de Comunicação', value: 'Secretaria Executiva de Comunicação' },
    { label: 'URB - Autarquia de Urbanização e Meio Ambiente de Caruaru', value: 'URB - Autarquia de Urbanização e Meio Ambiente de Caruaru' },
    { label: 'FUNDECA', value: 'FUNDECA' },
];



// WEBPACK FOOTER //
// ./src/app/_mocks/orgaos.ts